import React, { useState } from "react";
import { useEffect } from "react";


const InstructionViewer = ({ instructions, instructionString, setInstructionString }) => {
    const [selectedInstructionsList, setSelectedInstructionsList] = useState([])

    const handleChange = (e) => {
        setInstructionString(e?.target?.value)
    }

    useEffect(() => {

        if (instructions && instructions?.length) {
            const selectedInstructions = instructions
                .filter((ins) => ins.checked && !ins.isDeleted)
            if (selectedInstructions && selectedInstructions?.length) {
                setSelectedInstructionsList(selectedInstructions)
            }
        }
    }, [instructions])

    return (
        (instructionString) ?
            <div style={{ width: "100%", padding: "0px", marginTop: "15px" }}>
                <div className="card shadow-sm">
                    <div className="card-body">
                        <textarea
                            className="form-control"
                            rows="4"
                            value={instructionString}
                            onChange={(e) => handleChange(e)}
                        ></textarea>
                    </div>
                </div>
            </div> : null
    );
};

export default InstructionViewer;
